const EventNames = {
  BASE_VERIFICATION_STATUS_CHANGED: 'app.base_verification.status.changed',
  SESSION_TIMEOUT: 'app.session_timeout',
} as const;

export default EventNames;
